import { RouteType } from "../config";
import grupoInicio from "./grupoInicio";

import grupoConfiguracao from "./grupoConfiguracao";
import grupoAgenda from "./grupoAgenda";
import grupoCte from "./grupoCTe";
import grupoNIL from "./grupoNIL";
import grupoProgramaManutencao from "./grupoProgramaManutencao";
import grupoCompliance from "./grupoCompliance";
import grupoSolicitacaoPessoal from "./grupoSolicitacaoPessoal";

const rotas: RouteType[] = [
  grupoInicio,
  grupoAgenda,
  grupoCte,
  grupoProgramaManutencao,
  grupoSolicitacaoPessoal,
  grupoNIL,
  grupoCompliance,
  grupoConfiguracao,
];

export default rotas;
